import React, { createContext, useContext } from 'react';

const AspectRatioContext = createContext<number | null | undefined>(null);

type AspectRatioProviderProps = {
  ratio?: number | null;
  children: React.ReactElement;
};

export const AspectRatioProvider = ({ ratio, children }: AspectRatioProviderProps) => (
  <AspectRatioContext.Provider value={ratio}>{children}</AspectRatioContext.Provider>
);

export const useAspectRatio = (): number | null | undefined => {
  return useContext(AspectRatioContext);
};
